module.exports = __webpack_public_path__ + "img/Step.cbc85759.svg";